import React from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { FormikHelpers } from 'formik';
import { SignUpValidationSchema } from 'validations/profile/auth';

// components
import InnerForm from './InnerForm';
import ErrorHandlerService, {
  ErrorFromServer,
} from 'services/error-handler/service';
import { Form } from '@ui';

export interface FormValuesModel {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  password: string;
  step: number;
  entityDescription: string;
  passwordConfirm: string;
  accountType: string | null;
  keyRelationshipTemplateId: string | null;
}

interface IProps {
  initialFormValues: FormValuesModel;
  onSubmit: (
    values: FormValuesModel,
    formHelpers: FormikHelpers<FormValuesModel>,
  ) => Promise<void>;
}

const SignUpForm = ({ onSubmit, initialFormValues }: IProps) => {
  const { t } = useTranslation(['server_errors', 'auth', 'common']);

  const handleSubmit = async (
    values: FormValuesModel,
    helpers: FormikHelpers<FormValuesModel>,
  ) => {
    await onSubmit(values, helpers);
  };

  const handleOnSubmitError = (
    error: ErrorFromServer,
    _: FormValuesModel,
    formikHelpers: FormikHelpers<FormValuesModel>,
  ) => {
    const errorCode = ErrorHandlerService.getErrorCodeFromError(error);
    switch (errorCode) {
      case '1001007': {
        formikHelpers.setFieldError('email', t('1001007'));
        break;
      }
      default: {
        ErrorHandlerService.handleError(error);
        break;
      }
    }
  };

  return (
    <Form<FormValuesModel>
      onSubmit={handleSubmit}
      renderForm={<InnerForm />}
      initialValues={initialFormValues}
      onSubmitError={handleOnSubmitError}
      validationSchema={SignUpValidationSchema}
    />
  );
};

export default SignUpForm;
